import React, { FC } from 'react';

import { ResponsiveCarousel } from 'components/responsive-carousel';

import { RecentItemsCarouselContainer } from './recent-items-carousel-container.styled';

export interface ICardCarouselProps {
  children: React.ReactNode[];
  bgColor?: string;
}

const CarouselContainer: FC<ICardCarouselProps> = ({ children, bgColor }) => (
  <RecentItemsCarouselContainer>
    <ResponsiveCarousel bgColor={bgColor}>{children}</ResponsiveCarousel>
  </RecentItemsCarouselContainer>
);

export default CarouselContainer;
